// extracted by mini-css-extract-plugin
module.exports = {"custom-link-button__disabled":"_3RR9-krqKfgaeZgVXp_yML","custom-link-button":"_10v-5YlNbRJ-hhR6VEZAMC"};